<iframe *ngIf="!impressaoEstaAtiva" id="iframe-pedido" name="iframe-pedido" [src]="urlPedido | safeUrl"></iframe>


<ng-container *ngIf="impressaoEstaAtiva">
    <main *ngIf="!isLoading">
        <div id="print" [innerHTML]="htmlVisualizacao">

        </div>

        <div id="button-print">
            <a mat-flat-button mat-flat-button (click)="imprimir()">
                Imprimir
            </a>
        </div>
    </main>

    <div id="loading" *ngIf="isLoading">
        <h2 style="margin: 0;">Carregando....</h2>
    </div>
</ng-container>